var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-row",
        { attrs: { justify: "center" } },
        [
          _c(
            "v-dialog",
            {
              staticClass: "modal_medium",
              attrs: { persistent: "" },
              model: {
                value: _vm.visible,
                callback: function ($$v) {
                  _vm.visible = $$v
                },
                expression: "visible",
              },
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-form",
                    {
                      ref: "form",
                      attrs: {
                        method: "post",
                        enctype: "multipart/form-data",
                        "lazy-validation": "",
                      },
                      model: {
                        value: _vm.valid,
                        callback: function ($$v) {
                          _vm.valid = $$v
                        },
                        expression: "valid",
                      },
                    },
                    [
                      _c("v-card-title", [
                        _c("span", { staticClass: "headl" }, [
                          _vm._v("EDITAR COMUNICACIÓN CON API"),
                        ]),
                      ]),
                      _c(
                        "v-card-text",
                        [
                          _c(
                            "v-container",
                            [
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    {
                                      attrs: { cols: "12", sm: "12", md: "12" },
                                    },
                                    [
                                      _c(
                                        "p",
                                        { staticClass: "important_copy" },
                                        [
                                          _c("b", [_vm._v("IMPORTANTE")]),
                                          _vm._v(" "),
                                          _c("br"),
                                          _vm._v(
                                            " Esta acción necesita un reinicio de todas las instancias de la aplicación dentro del servidor, simplemente pare los servicios y vuelvas a iniciarlos. "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", sm: "6", md: "6" } },
                                    [
                                      _c("v-text-field", {
                                        ref: "name",
                                        attrs: {
                                          rules: _vm.nameRules,
                                          label: "Nombre",
                                          required: "",
                                          disabled: "",
                                        },
                                        model: {
                                          value: _vm.data.name,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.data, "name", $$v)
                                          },
                                          expression: "data.name",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", sm: "6", md: "6" } },
                                    [
                                      _c("v-text-field", {
                                        ref: "time",
                                        attrs: {
                                          type: "number",
                                          rules: [
                                            _vm.fieldRules.nullField,
                                            _vm.fieldRules.zeroField,
                                          ],
                                          label: "Tiempo en minutos",
                                          required: "",
                                        },
                                        model: {
                                          value: _vm.data.time,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.data,
                                              "time",
                                              _vm._n($$v)
                                            )
                                          },
                                          expression: "data.time",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-card-actions",
                        [
                          _c("v-spacer"),
                          _c(
                            "div",
                            { staticClass: "ctn_btn_shop" },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: { large: "", text: "" },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      _vm.show = false
                                    },
                                  },
                                },
                                [_vm._v("Cerrar")]
                              ),
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    disabled: !_vm.valid,
                                    depressed: "",
                                    large: "",
                                    color: "primary",
                                  },
                                  on: { click: _vm.validate },
                                },
                                [_vm._v("GUARDAR")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }